function init_tabs() {
  var hash = window.location.hash;

  hash &&
    $('ul.nav a[href="' + hash + '"]').tab("show") &&
    $('[data-bs-target="' + hash + '"]').tab("show");

  $(document).on("click", ".nav-tabs a,.nav-tabs button", function (e) {
    e.preventDefault();

    $(this).tab("show");

    hash = jQuery(this).attr("data-bs-target");
    // var scrollmem = $('body').scrollTop() || $('html').scrollTop();
    //window.location.hash = hash;
    history.replaceState({}, "", hash);
    // $('html,body').scrollTop(scrollmem);
  });
}
$(document).ready(function () {
  // Setup - add a text input to each footer cell
  $("#collections-items thead tr")
    .clone(true)
    .addClass("filters")
    .appendTo("#collections-items thead");

  var table = $("#collections-items").DataTable({
    orderCellsTop: true,
    scrollX: true,
    pageLength: 100,
    fixedHeader: true,
    responsive: true,
    columnDefs: [{ width: "7%", targets: 0 }],
    initComplete: function () {
      var api = this.api();

      // For each column
      api
        .columns()
        .eq(0)
        .each(function (colIdx) {
          // Set the header cell to contain the input element
          var cell = $(".filters th").eq(
            $(api.column(colIdx).header()).index()
          );
          if (jQuery(cell).hasClass("nofilter")) {
            $(cell).text("");
            return true;
          }
          var title = $(cell).text();
          $(cell).html('<input type="text" placeholder="' + title + '" />');

          // On every keypress in this input
          $(
            "input",
            $(".filters th").eq($(api.column(colIdx).header()).index())
          )
            .off("keyup change")
            .on("keyup change", function (e) {
              e.stopPropagation();

              // Get the search value
              $(this).attr("title", $(this).val());
              var regexr = "({search})"; //$(this).parents('th').find('select').val();

              var cursorPosition = this.selectionStart;
              // Search the column for that value
              api
                .column(colIdx)
                .search(
                  this.value != ""
                    ? regexr.replace("{search}", "(((" + this.value + ")))")
                    : "",
                  this.value != "",
                  this.value == ""
                )
                .draw();

              $(this)
                .focus()[0]
                .setSelectionRange(cursorPosition, cursorPosition);
            });
        });
    },
  });

  $(window).on("hashchange", function () {
    init_tabs();
  });
  /*********************** */

  $(function () {
    init_tabs();
  });

  ///showLabelItems

  //para los tooltips
  $("body").tooltip({
    selector: ".tooltip-checklist",
    title: hoverGetData,
    html: true,
    container: "body",
  });
  function hoverGetData() {
    var element = $(this);

    var id = element.data("id");

    if (id in itemsOfCollection) {
      if (itemsOfCollection[id]) {
        havechangea = element.data("havechangea");
        havechangeopena = element.data("havechangeopena");
        havechangereceiveda = element.data("havechangereceiveda");
        ext='';
        if (havechangea > 0) { ext = '<br>';
          ext = ext + '<b>Cambios a Recibir:</b><br>'
          if (havechangeopena) {
            ext = ext + '-Tienes ' + havechangeopena + ' Cambios pendientes';
          }
          if (havechangereceiveda) {
            ext = ext + '-Tienes ' + havechangereceiveda + ' Cambios completados';
          }
        }
        havechangeb = element.data("havechangeb");
        havechangeopenb = element.data("havechangeopenb");
        havechangereceivedb = element.data("havechangereceivedb");
        
        if (havechangeb > 0) { ext = ext+ '<br>';
          ext = ext + '<b>Cambios a Entregar:</b><br>'
          if (havechangeopenb) {
            ext = ext + '-Tienes ' + havechangeopenb + ' Cambios pendientes';
          }
          if (havechangereceivedb) {
            ext = ext + '-Tienes ' + havechangereceivedb + ' Cambios completados';
          }
        }
        return itemsOfCollection[id].label + ext;
      } else {
        return false;
      }
    }

    var localData = "error";

    $.ajax("/your/url/" + id, {
      async: false,
      success: function (data) {
        localData = data;
      },
    });

    cachedData[id] = localData;

    return localData;
  }
});

/***************** */
var changeTable;
var changeTableRecibidos;
var changeTableCancelados;

function initTableChange(tableId) {
  changeTableTemp = $("#" + tableId).DataTable({
    orderCellsTop: true,

    responsive: true,
    ajax: {
      url: "/api/api_getChangesList?op=" + tableId,
      dataSrc: "",
    },
    pageLength: 100,
    columns: [
      { data: "id" },
      { data: "contact_name" },
      { data: "collections_name" },
      { data: "itemsB" },
      { data: "itemsA" },

      { data: "created" },
      { data: "check01c", width: "2%" },
      { data: "check02c", width: "2%" },
      { data: "check03c", width: "2%" },
      { data: "check04c", width: "2%" },
      { data: "changes_status_id" },
      { data: "acciones" },
    ],

    initComplete: function () {
      var table = this.api();

      // Add filtering
      this.api()
        .columns()
        .every(function () {
          var column = this;

          /*
          var input = $('<input type="text" />')
            .appendTo($("  thead tr:eq(1) th").eq(this.index()))
            .on("keyup", function () {
              column.search($(this).val()).draw();
            });
            */

          var topHeaderCell = $("#" + tableId + " thead tr:eq(0) th").eq(
            this.index()
          );
          var secondHeaderCell = $("#" + tableId + " thead tr:eq(1) th").eq(
            this.index()
          );

          // Copiar los estilos
          secondHeaderCell.css("display", topHeaderCell.css("display"));
          secondHeaderCell.css("width", topHeaderCell.css("width"));

          console.log(this.index());
          var numeros = [2, 6, 7, 8, 9, 10];
          if (numeros.includes(this.index())) {
            var select = $(
              '<select style="width:100%"><option value=""></option></select>'
            )
              .appendTo(
                $("#" + tableId + "  thead tr:eq(1) th").eq(this.index())
              )
              .on("change", function () {
                var val = $.fn.dataTable.util.escapeRegex($(this).val());

                column.search(val ? "^" + val + "$" : "", true, false).draw();
              });

            column
              .data()
              .unique()
              .sort()
              .each(function (d, j) {
                d = jQuery(d).text();
                select.append('<option value="' + d + '">' + d + "</option>");
              });
          }
        });
    },
    // Configuración de la tabla según tus necesidades
  });

  changeTableTemp.on("responsive-resize", function (e, datatable, columns) {
    var count = columns.reduce(function (a, b, index) {
      console.log("index=" + index + " b= " + b);

      var topHeaderCell = $("#" + tableId + " thead tr:eq(0) th").eq(index);
      var secondHeaderCell = $("#" + tableId + " thead tr:eq(1) th").eq(index);

      // Copiar los estilos
      secondHeaderCell.css("display", topHeaderCell.css("display"));
      secondHeaderCell.css("width", topHeaderCell.css("width"));

      return b === false ? a + 1 : a;
    }, 0);

    console.log(columns);
    console.log(count + " column(s) are hidden");
  });
  return changeTableTemp;
}

$(function () {
  $('#nav-tab  [data-bs-toggle="tab"]').on("shown.bs.tab", function (e) {
    // Se ejecutará después de que un tab sea visible
    var targetTab = $(e.target).attr("data-bs-target"); // ID del tab activo
    console.log("Tab visible:", targetTab);

    changeTable.columns.adjust().draw();

    changeTableRecibidos.columns.adjust().draw();

    changeTableCancelados.columns.adjust().draw();
  });
});

$(document).ready(function () {
  // Inicializar DataTables
  //table.columns.adjust().draw();
  changeTable = initTableChange("changeTable");
  changeTableRecibidos = initTableChange("changeTableRecibidos");
  changeTableCancelados = initTableChange("changeTableCancelados");
  // Abrir la ventana modal al hacer clic en el botón "Agregar Cambio"

  // Guardar el cambio cuando se haga clic en el botón "Guardar Cambio"
  $("#btnSaveChange").click(function () {
    // Aquí puedes obtener los datos del formulario y enviarlos al servidor, por ejemplo, mediante una solicitud AJAX.
    // Luego, agregar la fila a la tabla con los datos del cambio guardado.

    // Una vez que hayas guardado el cambio, cierra la ventana modal
    $("#modalAddEdit").modal("hide");

    // Limpia el formulario para futuros usos
    $("#changeForm")[0].reset();

    changeTable.ajax.reload();
    changeTableRecibidos.ajax.reload();
    changeTableCancelados.ajax.reload();
  });

  // Implementa la lógica para borrar un cambio cuando se haga clic en el botón "BORRAR" de la tabla
  $("#changeTable").on("click", ".btn-delete", function () {
    // Obtén el ID del cambio que se va a borrar
    const changeId = $(this).data("changeid");

    // Aquí puedes enviar una solicitud AJAX al servidor para borrar el cambio con el ID correspondiente.

    // Luego, puedes eliminar la fila de la tabla que contiene el cambio borrado
    table.row($(this).closest("tr")).remove().draw();
  });
});

$(document).ready(function () {
  // Evento para capturar el cambio en el input de filtro
  $(document).on("input", ".table-mode-2-input", function () {
    let tableID = "#" + jQuery(this).data("target");
    var filtro = $(this).val().toLowerCase(); // Obtener el valor del input en minúsculas

    // Filtrar las filas de la tabla
    $("table" + tableID + " tbody tr").filter(function () {
      $(this).toggle($(this).text().toLowerCase().indexOf(filtro) > -1);
    });
  });
});

$(function (e) {
  jQuery("body").on("click", ".jsNewTab", function (e) {
    if (isMobile()) {
    } else {
      e.preventDefault(); // Evitar el comportamiento predeterminado de abrir el enlace
      window.open(jQuery(this).attr("href"), "NuevaVentana"); // Abrir enlace en nueva pestaña
    }
  });
});
